import styles from 'components/PageLayout/Header/styles.module.scss';

import React, { FC, HTMLProps } from 'react';
import cx from 'clsx';

import { CloverLogo } from 'components/CloverLogo';
import { HEADER_TEST_ID } from 'components/PageLayout/Header/consts';
import { useTranslation } from 'react-i18next';

type BasicHeaderProps = HTMLProps<HTMLElement> & {
  to?: string;
};

export const BasicHeader: FC<BasicHeaderProps> = ({ to, children }) => {
  const { t } = useTranslation();

  return (
    <header className={cx(styles.header)} data-testid={HEADER_TEST_ID}>
      <div className={styles.container}>
        <a
        title="Clover"
        href= {to}
        className={cx(styles.logoContainer, 'logo-basic-header')}
        aria-label={t('menu')}
        >
          <CloverLogo focusable={false} aria-hidden />

        </a>
        {children}
      </div>
    </header>
  );
};
